/* Enable browser-specific html class */
(function(){
/* Enable html class for IE browsers */
try {
	if(navigator.appVersion.indexOf("MSIE 7.")!=-1) {
		$("html").addClass("ie7"); 
	}
} 
catch(e){}

try {
	if(navigator.appVersion.indexOf("MSIE 8.")!=-1) {
		$("html").addClass("ie8"); 
	}
} 
catch(e){}

try {
	if(navigator.appVersion.indexOf("MSIE 9.")!=-1) {
		$("html").addClass("ie9"); 
	}
} 
catch(e){}

try {
	if(navigator.appVersion.indexOf("MSIE 10.")!=-1) {
		$("html").addClass("ie10"); 
	}
} 
catch(e){}

try {
	var isTrident = navigator.userAgent.match(/Trident\/7/);
	var isIE11 = navigator.userAgent.match(/rv:11/);
	if (isIE11=='rv:11' && isTrident=='Trident/7') {
		$("html").addClass("ie11");   
	}
} catch(e){}

try {
	if(!!navigator.userAgent.match(/Edge\/(\d)/i)) {
		var version = navigator.userAgent.match(/Edge\/(\d*)/i)[1];
		$("html").addClass("edge");  
		$("html").addClass("edge" + version);   
	}
} catch(e){}


/* Enable html class for Safari browser */
try {
  if(navigator.vendor == 'Apple Computer, Inc.') {
  	  $("html").addClass("safari");
  	  
  	  if(navigator.userAgent.toLowerCase().indexOf('version/8') > -1) {
  	  	  $("html").addClass("safari8");
  	  }
  	  if(navigator.userAgent.toLowerCase().indexOf('version/7.1') > -1) {
  	  	  $("html").addClass("safari8");
  	  }
  	  if(navigator.userAgent.toLowerCase().indexOf('version/9') > -1) {
  	  	  $("html").addClass("safari8");
  	  }
  	  if(navigator.userAgent.toLowerCase().indexOf('windows') > -1) {
		  $("html").addClass("winSafari");
  	  }
  }
}
catch(e){}

/* Enable html class for Chrome browser */
try {
	if(navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && !navigator.userAgent.match(/Edge\/(\d)/i)) {
		$("html").addClass("chrome");
		
		if(navigator.userAgent.toLowerCase().indexOf('windows') > -1) {
			$("html").addClass("winChrome");
		}
		
		var vers = navigator.userAgent.match(/Chrome\/(\d+)/);
		vers = +vers[1];
		
		if (vers > 46) {
			$("html").addClass("chrome47");
		}
		
		if (vers > 49) {
			$("html").addClass("chrome50");
		}
	}
}
catch(e){}

/* Enable html class for Firefox browser */
try {
	if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
		
		$("html").addClass("firefox");
		
		if(navigator.userAgent.toLowerCase().indexOf('windows') > -1) {
			$("html").addClass("winFirefox");
		}
		
	} 
}
catch(e){}

/* Enable html class for Opera browser */
try {
	if(navigator.userAgent.indexOf("Opera")!=-1) {
		$("html").addClass("opera"); 
	}
} 
catch(e){}


try {
	/* Enable html class for ipad device */
	if (!!navigator.userAgent.match(/iPad/i)) {
		$("html").addClass("iPad");
	}

	/* Enable html class for iphone device */
	if (!!navigator.userAgent.match(/iPhone/i)) {
		$("html").addClass("iPhone");
	}
	
	if (!!navigator.userAgent.match(/android\s4\.4\.2/)) {
		$("html").addClass("android442");
	}
}
catch(e){}


/* add os specific classes */
try {
	var version;
	var mainVersion;
	var windowsVersions = {
		'6.1': '7',
		'6.2': '8',
		'6.3': '8',
		'10': '10'
	};
	var u = navigator.userAgent;
	
	if (!!u.match(/Windows/i)) {
		$("html").addClass("windows");
		if(!!u.match(/Windows NT/i)) {
			version = u.match(/Windows NT (6\.\d|10)/i)[1];
			$("html").addClass("windows" + windowsVersions[version]);
		}
		if(!!u.match(/Windows Phone/i)) {
			version = u.match(/Windows Phone (6\.\d|10)/i)[1];
			$("html").addClass("winphone"); 
			$("html").addClass("windows" + windowsVersions[version]);
		}
	}
	
	if (!!u.match(/os x \d/i)) {
		$("html").addClass("osx");
		
		version = u.match(/os\sx\s(\d*_?\d*_?\d*)/i)[1];
		mainVersion = u.match(/os\sx\s(\d*)/i)[1];
		$("html").addClass("osx" + version).addClass("osx" + mainVersion);
	}
	
	if (!!u.match(/Linux/i)) {
		$("html").addClass("linux");
	}
	
	if (!!u.match(/iPhone|iPad/i)) {
		$("html").addClass("ios");
		
		version = u.match(/os\s(\d*_?\d*_?\d*)/i)[1];
		mainVersion = u.match(/os\s(\d*)/i)[1];
		$("html").addClass("ios" + version).addClass("ios" + mainVersion);
	}
	
	if (!!u.match(/android/i)) {
		$("html").addClass("android");
		
		version = u.match(/android\s(\d*\.?\d*\.?\d*)/i)[1].replace(/\./g, '_');
		mainVersion = u.match(/android\s(\d*)/i)[1];
		$("html").addClass("android" + version).addClass("android" + mainVersion);
	}
	
	
}catch(e) {
}

}());